const signatureData = {
  general: {
    photo: "",
    name: "",
    designation: "",
    company: "",
    officeAddress: "",
    branch:"",
    awards:[],
  },
  contacts: {
    telephone: "",
    phone: " ",
    email: "",
    website: "https://www.multidynamic.com.au",
    address: "",
    location: "",
  },
  social: {
    facebook: "",
    linkedin: "",
    github: "",
    twitter: "",
    instagram: "",
    youtube: "",
  },
  emailSignature: {
    banner: "",
    awards: [],
    reviewText: "",
  }
};

export default signatureData;
